<div class="d-flex flex-column justify-content-center text-center mb-3">
    <span class="titulo">Escolha o grupo de resposta</span>
    <div *ngFor="let grupo of grupos" class="mt-3 escolha" (click)="salvarGrupo(grupo)" [ngClass]="{'selecionado': fk_grupo == grupo}">
        <span class="textos">{{grupo.vc_nome}}</span>
        <div class="d-flex flex-row justify-content-center align-items-center">
            <div *ngFor="let nota of grupo.notas" class="m-2">
                <img [src]="nota.vc_icone"/>
            </div>
        </div>
    </div>
    <button class="botao-selecionar" [mat-dialog-close]="fk_grupo">Selecionar</button>
</div>